<script>
export default {
    name: "Highlights"
}
</script>

<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import highlights
</style>
